<template>
  <div>
    <el-card>
      <edit-form
        :disabled="isDisableEditForm"
        :customerExportTemplateCode="params.customerExportTemplateCode"
        :isCopy="isCopy"
        ref="editForm"
      />
      <!-- <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div> -->
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'system-sysCustomerExport-detail',
  components: {
    EditForm,
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
    isCopy() {
      return this.pageType === 'copy'
    }
  },
  methods: {
    save() {
      this.$refs.editForm.save()
    },
  },
}
</script>
